<template>
  <v-dialog persistent v-model="dialogModalExcluir" max-width="500px">
    <v-card style="background-color: #cc0033;">
      <v-card-title primary-title>
        <p style="color: white; margin: auto; text-align: center;" v-html="txtModal"></p>
      </v-card-title>
      <v-card-actions>
        <v-btn
          color="white"
          style="margin: auto; text-align: center;"
          @click="$emit('apagarRevendedor')"
          :loading="loaderExcluir"
        >Sim</v-btn>
        <v-btn
          color="white"
          style="margin: auto; text-align: center;"
          @click="$emit('fecharDialog')"
        >Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialogModalExcluir: {
      type: Boolean,
      default: false
    },
    loaderExcluir: {
      type: Boolean,
      default: false
    },
    loaderExcluirCliente: {
      type: Boolean,
      default: false
    },
    txtModal: {
      type: String,
      default: ""
    }
  }
};
</script>